var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{staticStyle:{"margin-top":"0px","margin-left":"44px"},attrs:{"disabled":_vm.disabled,"hide-details":""},model:{value:(_vm.setChecker),callback:function ($$v) {_vm.setChecker=$$v},expression:"setChecker"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }